import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  getChatsService,
  sendChatMessageService
} from 'network/services/chat.service'

export const sendChatMessage = createAsyncThunk(
  'chat/send-message',
  async (data, thunkApi) => {
    try {
      const res = await sendChatMessageService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description || 'Failed to send message')
    }
  }
)

export const getChats = createAsyncThunk(
  'fetch/chats',
  async (data, thunkApi) => {
    try {
      const res = await getChatsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0]?.description || 'Failed to fetch chats')
    }
  }
)
